import(/* webpackMode: "eager" */ "/vercel/path0/src/app/propietarios/page.tsx");
